// dependencies
import React from "react";
import { Link } from "yarrr";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { startOfWeek, subWeeks, format, isBefore, parseISO } from "date-fns";

// components
import Button from "Components/Button";

// actions

// selectors

// hooks
import useRequest from "Hooks/useRequest";

// css
import css from "./SecurityAudits.styl";

const SecurityAudits = () => {
	const { data } = useRequest("Get Security Audits");
	const audits = data ? data.audits : [];
	const domain = PRODUCTION ? "https://wolverine.talent.performyard.com" : "http://localhost:4000";

	return (
		<div>
			<div className={css.auditTable}>
				<div className={`${css.tableRow} ${css.auditHead}`}>
					<div className={css.headItem}>Security Audits</div>
					<div className={css.headItem}>Date</div>
					<div className={css.headItem}>Total Time</div>
					<div className={css.headItem}>Total Checks</div>
					<div className={css.headItem}>Passed</div>
					<div className={css.headItem}>Failed</div>
				</div>

				{audits.map((audit) => {
					const { _id, createdAt, date, totalChecks, failedChecks, passedChecks, totalTime } = audit;

					const createdAtParsed = parseISO(createdAt);

					return (
						<div className={`${css.audit} ${css.tableRow}`} key={_id}>
							<div className={css.bodyItem}>
								<Button
									className={css.viewButton}
									external={true}
									href={`${domain}/security/audits/${date}`}
								>
									View
								</Button>
							</div>
							<div className={css.bodyItem}>{format(createdAtParsed, "MMM d h:mm a")}</div>
							<div className={css.bodyItem}>{`${totalTime} minutes`}</div>
							<div className={css.bodyItem}>{totalChecks}</div>
							<div className={css.bodyItem}>{passedChecks}</div>
							<div className={css.bodyItem}>{failedChecks}</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default SecurityAudits;
